import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { IITH } from '@/pages/landing/iithBrand';
import { opdTariffApi } from '../api/opdTariff.api';
import ClinicTariffConfigForm from './ClinicTariffConfigForm';

const EMPTY = {
  categories: { faculty_staff: 0, dependent: 0, non_dependent: 300, other: 300 },
  affiliations: {
    faculty_staff_relative: 200, guest: 400, project_staff: 300,
    intern: 200, contractor: 350, other: 400,
  },
};

function mergeTariff(t) {
  return {
    ...EMPTY,
    ...t,
    categories: { ...EMPTY.categories, ...(t?.categories || {}) },
    affiliations: { ...EMPTY.affiliations, ...(t?.affiliations || {}) },
  };
}

/** Consultation tariffs section — own load + save. */
export default function ClinicTariffConfigSection() {
  const [tariff, setTariff] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    opdTariffApi.get()
      .then((t) => setTariff(mergeTariff(t)))
      .catch((e) => toast.error(e?.response?.data?.detail || 'Could not load tariffs'))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      setTariff(mergeTariff(await opdTariffApi.update(tariff)));
      toast.success('Tariff settings saved');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not save tariffs');
    }
    setSaving(false);
  };

  if (loading) {
    return <div className="py-12 text-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin inline" /></div>;
  }

  return (
    <div className="space-y-4" data-testid="tariff-config-section">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-[#071B34]">Consultation tariffs</h3>
          <p className="text-sm text-[#5A6B7C] mt-0.5">
            Category and affiliation fees. ₹0 fees skip payment at reception.
          </p>
        </div>
        <Button onClick={save} disabled={saving} style={{ background: IITH.saffron }}
          className="text-white" data-testid="tariff-section-save">
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
          Save tariffs
        </Button>
      </div>
      <ClinicTariffConfigForm form={tariff} setForm={setTariff} />
    </div>
  );
}
